module.exports = __webpack_public_path__ + "img/newspaper.fe375324.png";